(function ga4CustomEvents() {
  let gtag = window.gtag;

  A1_5min3page();
  A2_20_Percentages_Scroll();
  A3_6clicks();
  B1_Carousel_4_Images_View();
  B2_FAQ_or_Questions_Engaged();
  HansoExactTrackingEvents();

  function getStoredValue(key, defaultValue = false) {
    return localStorage.getItem(key)
      ? parseInt(localStorage.getItem(key), 10)
      : defaultValue;
  }

  function setStoredValue(key, value) {
    localStorage.setItem(key, value);
  }

  function pushExactEvent(eventName, data = {}) {
    const payload = Object.assign(
      {
        event: eventName,
        page: location.href,
        path: location.pathname,
        product_handle: location.pathname.includes('/products/')
          ? location.pathname.split('/products/')[1].split('/')[0]
          : '',
      },
      data
    );

    window.dataLayer = window.dataLayer || [];
    window.dataLayer.push(payload);

    if (typeof gtag === 'function') {
      gtag('event', eventName, payload);
    }
  }

  function hasTrackedEvent(eventName, storageScope = location.pathname) {
    return localStorage.getItem('hanso_exact_' + eventName + '_' + storageScope) === 'true';
  }

  function markTrackedEvent(eventName, storageScope = location.pathname) {
    localStorage.setItem('hanso_exact_' + eventName + '_' + storageScope, 'true');
  }

  function trackExactOnce(eventName, data = {}, storageScope = location.pathname) {
    if (hasTrackedEvent(eventName, storageScope)) return false;
    pushExactEvent(eventName, data);
    markTrackedEvent(eventName, storageScope);
    return true;
  }

  function HansoExactTrackingEvents() {
    exactSixClicks();
    exactThreeMinSixClicks();
    exactSizeInfo();
    exactConfiguratorEvents();
    exactFaqClicks();
    exactSixImages();
  }

  function exactSixClicks() {
    const eventName = '6_clicks';
    if (hasTrackedEvent(eventName, 'site')) return false;

    let clicks = getStoredValue('hanso_exact_6_clicks_count', 0);

    document.documentElement.addEventListener('click', function trackClicks() {
      clicks += 1;
      setStoredValue('hanso_exact_6_clicks_count', clicks);

      if (clicks >= 6) {
        trackExactOnce(eventName, {}, 'site');
        document.documentElement.removeEventListener('click', trackClicks);
      }
    });
  }

  function exactThreeMinSixClicks() {
    const eventName = '3_min_6_clicks';
    if (hasTrackedEvent(eventName, 'site')) return false;

    const startTime = Date.now();

    function getTotalClicks() {
      return getStoredValue('hanso_exact_6_clicks_count', 0);
    }

    function checkThreeMinSixClicks() {
      const currentSessionSeconds = Math.floor((Date.now() - startTime) / 1000);
      const storedSeconds = getStoredValue('hanso_exact_total_seconds', 0);
      const totalSeconds = storedSeconds + currentSessionSeconds;

      if (totalSeconds >= 180 && getTotalClicks() >= 6) {
        trackExactOnce(eventName, { total_seconds: totalSeconds, total_clicks: getTotalClicks() }, 'site');
        return true;
      }

      return false;
    }

    const timer = setInterval(function () {
      if (checkThreeMinSixClicks()) {
        clearInterval(timer);
      }
    }, 1000);

    window.addEventListener('beforeunload', function () {
      const currentSessionSeconds = Math.floor((Date.now() - startTime) / 1000);
      const storedSeconds = getStoredValue('hanso_exact_total_seconds', 0);
      setStoredValue('hanso_exact_total_seconds', storedSeconds + currentSessionSeconds);
    });
  }

  function exactSizeInfo() {
    document.addEventListener('click', function (event) {
      const sizeInfoButton = event.target.closest(
        '.hanso-product-main__option-link, [data-hanso-dimensions-open]'
      );

      if (!sizeInfoButton) return;

      trackExactOnce('size_info', { click_text: sizeInfoButton.textContent.trim() });
    });
  }

  function getConfiguratorInteractionType(target) {
    if (!target) return null;

    const trackedInteraction = target.closest(
      '[data-configurator-interaction], variant-selects fieldset, variant-selects .product-form__input'
    );
    if (trackedInteraction) {
      const explicitType = trackedInteraction.getAttribute('data-configurator-interaction') || '';
      const explicitKey = trackedInteraction.getAttribute('data-configurator-interaction-key') || '';
      const labelNode =
        trackedInteraction.querySelector('.hanso-product-main__option-title') ||
        trackedInteraction.querySelector('legend') ||
        trackedInteraction.querySelector('.form__label') ||
        trackedInteraction.querySelector('label');
      const labelText = labelNode ? labelNode.textContent.trim().toLowerCase() : '';
      let type = explicitType;

      if (!type) {
        if (labelText.includes('size')) type = 'size';
        else if (labelText.includes('color') || labelText.includes('finish') || labelText.includes('canvas')) type = 'color';
        else if (labelText.includes('style')) type = 'style';
        else type = 'product_option';
      }

      const optionGroups = Array.from(document.querySelectorAll('variant-selects .product-form__input'));
      const optionIndex = optionGroups.indexOf(trackedInteraction);

      return {
        key: explicitKey || 'option-' + (optionIndex >= 0 ? optionIndex + 1 : labelText || type),
        type: type,
        label: labelText,
      };
    }

    const optionCard = target.closest(
      '.hanso-product-main__option-card, .hanso-product-main__option-group input[type="radio"]'
    );
    if (optionCard) {
      const fieldset = optionCard.closest('.hanso-product-main__option-group');
      const legendText = fieldset
        ? (fieldset.querySelector('.hanso-product-main__option-title') || fieldset.querySelector('legend'))
            ?.textContent.toLowerCase()
        : '';

      let type = 'product_option';
      if (legendText.includes('size')) type = 'size';
      else if (legendText.includes('color') || legendText.includes('finish') || legendText.includes('canvas')) type = 'color';
      else if (legendText.includes('style')) type = 'style';

      return {
        key: fieldset?.getAttribute('data-configurator-interaction-key') || legendText || type,
        type: type,
        label: legendText,
      };
    }

    const addonTrigger = target.closest(
      '[data-addon-open], [data-addon-select], [data-hanso-upgrade-toggle], .hanso-product-addons__product-button'
    );
    if (addonTrigger) {
      const addonType = (
        addonTrigger.getAttribute('data-addon-type') ||
        addonTrigger.closest('[data-addon-type]')?.getAttribute('data-addon-type') ||
        ''
      ).toLowerCase();

      if (addonType.includes('sidewall') || addonType.includes('wall')) {
        return { key: 'walls', type: 'walls', label: addonType };
      }
      if (
        addonType.includes('accessor') ||
        addonType.includes('addon') ||
        addonType.includes('upgrade') ||
        addonTrigger.matches('[data-hanso-upgrade-toggle]')
      ) {
        return { key: 'accessories', type: 'accessories', label: addonType };
      }
    }

    return null;
  }

  function exactConfiguratorEvents() {
    const productScope = location.pathname;
    const interactionKey = 'hanso_exact_configurator_interactions_' + productScope;
    const clickedKeys = new Set(
      (sessionStorage.getItem(interactionKey) || '')
        .split(',')
        .map((item) => item.trim())
        .filter(Boolean)
    );
    const interactionTypes = new Set();

    function hasTrackedConfiguratorEvent(eventName) {
      return sessionStorage.getItem('hanso_exact_' + eventName + '_' + productScope) === 'true';
    }

    function trackConfiguratorEventOnce(eventName, data = {}) {
      if (hasTrackedConfiguratorEvent(eventName)) return false;
      pushExactEvent(eventName, data);
      sessionStorage.setItem('hanso_exact_' + eventName + '_' + productScope, 'true');
      return true;
    }

    function recordInteraction(interaction) {
      if (!interaction || !interaction.key || !location.pathname.includes('/products/')) return;

      clickedKeys.add(interaction.key);
      interactionTypes.add(interaction.type);
      sessionStorage.setItem(interactionKey, Array.from(clickedKeys).join(','));

      trackConfiguratorEventOnce('pro_perg_configurator_start', {
        interaction_key: interaction.key,
        interaction_type: interaction.type,
        interaction_label: interaction.label,
      });

      if (clickedKeys.size >= 3) {
        trackConfiguratorEventOnce(
          'pro_perg_configurator_midway',
          {
            interaction_keys: Array.from(clickedKeys).join(','),
            interaction_types: Array.from(interactionTypes).join(','),
          }
        );
      }
    }

    document.addEventListener('click', function (event) {
      recordInteraction(getConfiguratorInteractionType(event.target));

      const addButton = event.target.closest(
        '.hanso-product-main__submit, [type="submit"][name="add"], product-form button[type="submit"]'
      );

      if (addButton && clickedKeys.size >= 3) {
        trackConfiguratorEventOnce(
          'pro_perg_configurator_complete',
          {
            interaction_keys: Array.from(clickedKeys).join(','),
            interaction_types: Array.from(interactionTypes).join(','),
          }
        );
      }
    });

    document.addEventListener('change', function (event) {
      recordInteraction(getConfiguratorInteractionType(event.target));
    });
  }

  function trackFaqThreshold(eventName, selector) {
    const clickedQuestions = new Set();

    document.addEventListener('click', function (event) {
      const question = event.target.closest(selector);
      if (!question) return;

      const questionText = question.textContent.trim();
      if (questionText) {
        clickedQuestions.add(questionText);
      } else {
        clickedQuestions.add(String(clickedQuestions.size + 1));
      }

      if (clickedQuestions.size >= 3) {
        trackExactOnce(eventName, { question_count: clickedQuestions.size });
      }
    });
  }

  function exactFaqClicks() {
    trackFaqThreshold('mini_faq_3', '[data-product-main-faq-question]');
    trackFaqThreshold('faq_3', '[data-pdp-faq-question]');
  }

  function exactSixImages() {
    const eventName = '6_images';
    const storageScope = location.pathname;
    if (hasTrackedEvent(eventName, storageScope)) return false;

    let imageInteractions = getStoredValue('hanso_exact_6_images_count_' + storageScope, 0);
    let touchStartX = null;
    let touchStartY = null;

    function recordImageInteraction(interactionType) {
      if (!location.pathname.includes('/products/')) return;
      if (hasTrackedEvent(eventName, storageScope)) return;

      imageInteractions += 1;
      setStoredValue('hanso_exact_6_images_count_' + storageScope, imageInteractions);

      if (imageInteractions >= 6) {
        trackExactOnce(eventName, { interaction_type: interactionType, image_interactions: imageInteractions }, storageScope);
      }
    }

    document.addEventListener('click', function (event) {
      const imageControl = event.target.closest(
        '[data-pdp-gallery-thumb], [data-pdp-gallery-prev], [data-pdp-gallery-next], .hanso-product-main__gallery-thumb, .hanso-product-main__gallery-arrow'
      );

      if (imageControl) {
        recordImageInteraction('click');
      }
    });

    document.addEventListener(
      'touchstart',
      function (event) {
        const gallery = event.target.closest('[data-hanso-product-main], [data-pdp-gallery-track]');
        if (!gallery || !event.touches || !event.touches.length) return;
        touchStartX = event.touches[0].clientX;
        touchStartY = event.touches[0].clientY;
      },
      { passive: true }
    );

    document.addEventListener(
      'touchend',
      function (event) {
        if (touchStartX === null || touchStartY === null || !event.changedTouches || !event.changedTouches.length) return;

        const gallery = event.target.closest('[data-hanso-product-main], [data-pdp-gallery-track]');
        const deltaX = event.changedTouches[0].clientX - touchStartX;
        const deltaY = event.changedTouches[0].clientY - touchStartY;

        touchStartX = null;
        touchStartY = null;

        if (!gallery) return;
        if (Math.abs(deltaX) > 40 && Math.abs(deltaX) > Math.abs(deltaY)) {
          recordImageInteraction('swipe');
        }
      },
      { passive: true }
    );
  }

  function A1_5min3page() {
    const timeThreshold = 5 * 60; // 5 minutes in seconds
    const pageThreshold = 3;
    let eventName = "A1_5min3page";
    let eventTriggered = localStorage.getItem("A1_5min3page") === "true"; // Prevent multiple executions
    let startTime = Date.now();

    function getStoredValue(key, defaultValue = false) {
      return localStorage.getItem(key)
        ? parseInt(localStorage.getItem(key), 10)
        : defaultValue;
    }

    function setStoredValue(key, value) {
      localStorage.setItem(key, value);
    }

    // Retrieve existing values or initialize them
    let totalTimeOnSite = getStoredValue("totalTimeOnSite", 0);
    let pagesVisited = getStoredValue("pagesVisited", 1);
    console.warn("totalTimeOnSite: ", totalTimeOnSite);
    console.warn("pagesVisited: ", pagesVisited);

    function checkConditions() {
      //console.warn("eventTriggered: ", eventTriggered);
      //console.warn("totalTimeOnSite: ", totalTimeOnSite);
      //console.warn("pagesVisited: ", pagesVisited);
      if (
        !eventTriggered &&
        totalTimeOnSite >= timeThreshold &&
        pagesVisited >= pageThreshold
      ) {
        trackEvent();
        eventTriggered = true;
        setStoredValue(eventName, "true");
      }
    }

    function trackEvent() {
      console.warn("Function executed: User met both criteria.");

      // Send Event for A1_5min3page
      gtag("event", "A1_5min3page", {});
    }

    function updateTotalTime() {
      const currentTime = Date.now();
      totalTimeOnSite += Math.floor((currentTime - startTime) / 1000);
      startTime = currentTime;
      setStoredValue("totalTimeOnSite", totalTimeOnSite);
    }

    function trackPageViews() {
      updateTotalTime();
      pagesVisited++;
      setStoredValue("pagesVisited", pagesVisited);

      checkConditions();
    }

    // Track when the user leaves the page (for navigation or closing)
    window.addEventListener("beforeunload", trackPageViews);

    // Periodic check while the user stays on the same page
    setInterval(() => {
      if (getStoredValue("pagesVisited")) {
        updateTotalTime();
        checkConditions();
      }
    }, 1000);
  }

  function A2_20_Percentages_Scroll() {
    document.addEventListener("scroll", function checkScroll() {
      const scrollPosition = window.scrollY;
      const totalHeight =
        document.documentElement.scrollHeight - window.innerHeight;
      const scrollPercentage = (scrollPosition / totalHeight) * 100;

      if (scrollPercentage >= 20) {
        trackEvent();
        document.removeEventListener("scroll", checkScroll); // Remove listener to prevent repeated execution
      }
    });

    function trackEvent() {
      console.log("User has scrolled past 20% of the page!");

      // Send Event for A2_20_Percentages_Scroll
      gtag("event", "A2_20_Percentages_Scroll", {
        path: location.pathname,
      });
    }
  }

  function A3_6clicks() {
    let totalClicksThreshold = 6;
    let eventName = "A3_6clicks";
    let eventTriggered = localStorage.getItem(eventName) === "true"; // Prevent Multiple Executions
    if (eventTriggered) return false;

    // Obtain Current Number of Clicks
    let totalNumberOfClicks = getStoredValue(
      "keyEventsCurrentNumberOfClicks",
      0
    );

    document.documentElement.addEventListener(
      `click`,
      function trackA3_6clicks(e) {
        totalNumberOfClicks++;
        setStoredValue("keyEventsCurrentNumberOfClicks", totalNumberOfClicks);

        if (totalNumberOfClicks >= totalClicksThreshold) {
          trackEvent();

          document.documentElement.removeEventListener(
            `click`,
            trackA3_6clicks
          );
        }
      }
    );

    function trackEvent() {
      gtag("event", "A3_6clicks");
    }
  }

  function B1_Carousel_4_Images_View() {
    const imageViewedThreshold = 3;
    let eventName = "B1_Carousel_4_Images_View";
    let eventTriggered =
      localStorage.getItem(eventName + location.pathname) === "true"; // Prevent Multiple Executions
    if (eventTriggered) return false;
    let totalNumberOfClicks = 0;

    let carouselImages = [...document.querySelectorAll(`.product__thumb-item`)];

    if (eventTriggered) return false;

    if (!carouselImages.length) {
      setTimeout(B1_Carousel_4_Images_View, 100);
      return false;
    }

    let itemsWithEvents = [];
    carouselImages.forEach((item) => {
      itemsWithEvents.push(item);
      item.addEventListener(`click`, trackB1_Carousel_4_Images_ViewClicks);
    });
    function trackB1_Carousel_4_Images_ViewClicks(e) {
      if (e.target.querySelector(`.is-active`)) {
        return false;
      }

      totalNumberOfClicks++;

      if (totalNumberOfClicks >= imageViewedThreshold) {
        trackEvent();
        setStoredValue(eventName + location.pathname, "true");
        console.warn(`about to do it`);
        itemsWithEvents.forEach((cImage) => {
          console.warn(`cImage: `, cImage);
          cImage.removeEventListener(
            `click`,
            trackB1_Carousel_4_Images_ViewClicks
          );
        });
      }
    }

    function trackEvent() {
      gtag("event", "B1_Carousel_4_Images_View", { page: location.href });
    }
  }

  function B2_FAQ_or_Questions_Engaged() {
    let eventName = "B2_FAQ_or_Questions_Engaged";
    let eventTriggered =
      localStorage.getItem(eventName + location.pathname) === "true"; // Prevent Multiple Executions
    let faqAccordionItems = [
      ...document.querySelectorAll(`.accordion-title.jas-accordion-title`),
    ];

    if (eventTriggered) return false;

    if (!faqAccordionItems.length) {
      setTimeout(B2_FAQ_or_Questions_Engaged, 100);
      return false;
    }

    faqAccordionItems.forEach((item) => {
      item.addEventListener(
        `click`,
        function trackB2_FAQ_or_Questions_EngagedClick(e) {
          trackEvent();
          item.removeEventListener(
            `click`,
            trackB2_FAQ_or_Questions_EngagedClick
          );
          setStoredValue(eventName + location.pathname, "true");
        }
      );
    });

    function trackEvent() {
      gtag("event", "B2_FAQ_or_Questions_Engaged", { page: location.href });
    }
  }
})();
